
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Vendors
import moment from "moment";

// Models
import {AppCommonUser} from "@/models/app/common/User";
import {AppCommonTrainingCategory} from "@/models/app/common/training-category";

// Components
import {
  ElRow,
  ElCol,
  ElForm,
  ElFormItem,
  ElSelect,
  ElOption,
  ElDatePicker,
} from "element-plus";

@Options({
  props: [
    "players",
    "trainingCategories",
  ],
  components: {
    ElRow,
    ElCol,
    ElForm,
    ElFormItem,
    ElSelect,
    ElOption,
    ElDatePicker,
  },
})
export default class AppCoachTrainingsRootFilterIndexVue extends Vue {
  players: Array<AppCommonUser> = [];
  trainingCategories: Array<AppCommonTrainingCategory> = [];

  formData: any = {
    filter: {
      user_id: "*",
      training_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  getTrainingsByFilter(): void {
    this.$emit("getTrainingsByFilter", this.formData);
  }
}
